/**
 * Upsell Pop-up — KreStoffer
 * - Intercepter form submit via AJAX inkl. Infinite Options data
 * - Rører IKKE Expanses knap
 * - Viser variant + antal øverst
 * - Metervarer viser meterpris + cm
 * - Minimum 25 cm for metervarer i pop-up
 * - Opdaterer Expanses kurv-ikon
 * - Lagervalidering
 * - Tilbehør købt via pop-up får line item property "Valgt til: <produktnavn>"
 */

(function () {
  'use strict';

  (function injectStyles() {
    const style = document.createElement('style');
    style.textContent = `
      #upsell-popup-overlay {
        display: none;
        position: fixed;
        top: 0; left: 0;
        width: 100%; height: 100%;
        background: rgba(0,0,0,0.45);
        z-index: 99999;
        align-items: center;
        justify-content: center;
        padding: 16px;
        box-sizing: border-box;
      }
      .upsell-modal {
        background: #fff;
        border-radius: 12px;
        width: 100%;
        max-width: 680px;
        max-height: 88vh;
        display: flex;
        flex-direction: column;
        box-shadow: 0 8px 40px rgba(0,0,0,0.18);
      }
      .upsell-modal__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 24px;
        border-bottom: 1px solid #f0f0f0;
        flex-shrink: 0;
      }
      .upsell-modal__confirmed {
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: 600;
        font-size: 15px;
        color: #18AA04;
      }
      .upsell-modal__close {
        background: none;
        border: none;
        cursor: pointer;
        color: #666;
        padding: 6px;
        display: flex;
        align-items: center;
        border-radius: 50%;
        transition: background 0.15s;
      }
      .upsell-modal__close:hover { background: #f0f0f0; color: #111; }
      .upsell-modal__body { overflow-y: auto; -webkit-overflow-scrolling: touch; overscroll-behavior: contain; flex: 1; }
      .upsell-modal__added-product {
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 14px 24px;
        border-bottom: 1px solid #f0f0f0;
        background: #fafafa;
      }
      .upsell-modal__added-image {
        width: 56px;
        height: 56px;
        object-fit: cover;
        border-radius: 8px;
        border: 1px solid #eee;
        flex-shrink: 0;
      }
      .upsell-modal__added-title { font-size: 13px; font-weight: 600; margin: 0 0 2px; color: #111; }
      .upsell-modal__added-meta { font-size: 12px; color: #888; margin: 0 0 3px; }
      .upsell-modal__added-price { font-size: 13px; color: #18AA04; font-weight: 600; margin: 0; }
      .upsell-section { padding: 14px 24px; }
      .upsell-section__heading {
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.07em;
        color: #999;
        margin: 0 0 10px;
      }
      .upsell-list { display: flex; flex-direction: column; gap: 8px; }
      .upsell-list-card {
        display: grid;
        grid-template-columns: 52px minmax(0, 1fr) auto;
        align-items: center;
        gap: 10px;
        padding: 8px 10px;
        border: 1px solid #eee;
        border-radius: 8px;
        transition: border-color 0.15s;
      }
      .upsell-list-card:hover { border-color: #ccc; }
      .upsell-list-card__image {
        width: 52px;
        height: 52px;
        object-fit: cover;
        border-radius: 6px;
        border: 1px solid #f0f0f0;
      }
      .upsell-list-card__info { min-width: 0; }
      .upsell-list-card__title {
        font-size: 11px;
        font-weight: 600;
        color: #111;
        text-decoration: none;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin-bottom: 2px;
        line-height: 1.3;
      }
      .upsell-list-card__title:hover { text-decoration: underline; }
      .upsell-list-card__price { font-size: 12px; color: #18AA04; font-weight: 600; margin: 0; }
      .upsell-list-card__actions { display: flex; align-items: center; gap: 5px; flex-shrink: 0; }
      .upsell-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; }
      .upsell-grid-card {
        display: flex;
        flex-direction: column;
        border: 1px solid #eee;
        border-radius: 8px;
        overflow: hidden;
        transition: border-color 0.15s;
      }
      .upsell-grid-card:hover { border-color: #ccc; }
      .upsell-grid-card__image {
        width: 100%;
        aspect-ratio: 1 / 1;
        object-fit: cover;
        display: block;
        border-bottom: 1px solid #f0f0f0;
      }
      .upsell-grid-card__body { padding: 8px 10px; flex: 1; display: flex; flex-direction: column; }
      .upsell-grid-card__title {
        font-size: 12px;
        font-weight: 600;
        color: #111;
        text-decoration: none;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin-bottom: 3px;
        line-height: 1.3;
      }
      .upsell-grid-card__title:hover { text-decoration: underline; }
      .upsell-grid-card__price { font-size: 12px; color: #18AA04; font-weight: 700; margin: 0 0 8px; }
      .upsell-grid-card__actions { display: flex; align-items: center; gap: 4px; margin-top: auto; }
      .upsell-qty {
        display: flex;
        align-items: center;
        border: 1px solid #ddd;
        border-radius: 5px;
        overflow: hidden;
        flex-shrink: 0;
      }
      .upsell-qty__btn {
        background: #f5f5f5;
        border: none;
        width: 24px;
        height: 26px;
        cursor: pointer;
        font-size: 14px;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .upsell-qty__btn:hover { background: #e8e8e8; }
      .upsell-qty__input {
        width: 32px;
        height: 26px;
        border: none;
        text-align: center;
        font-size: 12px;
        font-weight: 600;
        color: #111;
        -moz-appearance: textfield;
      }
      .upsell-qty__input::-webkit-outer-spin-button,
      .upsell-qty__input::-webkit-inner-spin-button { -webkit-appearance: none; }
      .upsell-add-btn {
        flex: 1;
        background: #111;
        color: #fff;
        border: none;
        border-radius: 5px;
        height: 26px;
        padding: 0 8px;
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        white-space: nowrap;
        transition: background 0.15s;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
      }
      .upsell-add-btn:hover { background: #333; }
      .upsell-add-btn.is-added { background: #18AA04; }
      .upsell-add-btn:disabled:not(.is-added) { opacity: 0.6; cursor: not-allowed; }
      .upsell-variant-btn {
        flex: 1;
        background: #fff;
        color: #111;
        border: 1px solid #ddd;
        border-radius: 5px;
        height: 26px;
        padding: 0 8px;
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        white-space: nowrap;
        transition: border-color 0.15s;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
      }
      .upsell-variant-btn:hover { border-color: #999; }
      .upsell-skeleton-list { display: flex; flex-direction: column; gap: 8px; }
      .upsell-skeleton-item {
        display: grid;
        grid-template-columns: 52px 1fr;
        gap: 10px;
        padding: 8px 10px;
        border: 1px solid #eee;
        border-radius: 8px;
        animation: upsell-pulse 1.2s ease-in-out infinite;
      }
      .upsell-skeleton__img-sq { width: 52px; height: 52px; background: #eee; border-radius: 6px; }
      .upsell-skeleton__body { padding: 4px 0; }
      .upsell-skeleton__line { height: 11px; background: #eee; border-radius: 4px; margin-bottom: 7px; }
      .upsell-skeleton__line--short { width: 55%; }
      @keyframes upsell-pulse { 0%,100%{opacity:1} 50%{opacity:0.5} }
      .upsell-divider { height: 1px; background: #f0f0f0; margin: 0 24px; }
      .upsell-modal__actions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        padding: 14px 24px;
        border-top: 1px solid #f0f0f0;
        flex-shrink: 0;
      }
      .upsell-modal__btn {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 16px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        text-decoration: none;
        text-align: center;
        border: 2px solid transparent;
        box-sizing: border-box;
        transition: background 0.15s, border-color 0.15s;
      }
      .upsell-modal__btn--secondary { background: #fff; border-color: #ddd; color: #111; }
      .upsell-modal__btn--secondary:hover { border-color: #999; }
      .upsell-modal__btn--primary { background: #18AA04; color: #fff; }
      .upsell-modal__btn--primary:hover { background: #149003; }
      .upsell-modal__cart-count {
        background: rgba(255,255,255,0.25);
        border-radius: 10px;
        padding: 1px 7px;
        font-size: 12px;
      }
      @media (max-width: 600px) {
        #upsell-popup-overlay { align-items: flex-end; padding: 0; }
        .upsell-modal { border-radius: 16px 16px 0 0; max-height: 92vh; max-width: 100%; }
        .upsell-grid { grid-template-columns: repeat(2, 1fr); }
        .upsell-section,
        .upsell-modal__added-product,
        .upsell-modal__header,
        .upsell-modal__actions { padding-left: 16px; padding-right: 16px; }
        .upsell-divider { margin: 0 16px; }
      }
    `;
    document.head.appendChild(style);
  })();

  function createModal() {
    const el = document.createElement('div');
    el.id = 'upsell-popup-overlay';
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Produkt tilføjet til kurv');
    el.innerHTML = `
      <div class="upsell-modal" role="document">
        <div class="upsell-modal__header">
          <div class="upsell-modal__confirmed" aria-live="polite">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <circle cx="10" cy="10" r="10" fill="#18AA04"/>
              <path d="M5.5 10.5L8.5 13.5L14.5 7.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Lagt i kurven</span>
          </div>
          <button class="upsell-modal__close" aria-label="Luk">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
              <path d="M2 2L16 16M16 2L2 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        <div class="upsell-modal__body">
          <div class="upsell-modal__added-product">
            <img id="upsell-added-image" src="" alt="" class="upsell-modal__added-image" loading="lazy" width="56" height="56">
            <div>
              <p id="upsell-added-title" class="upsell-modal__added-title"></p>
              <p id="upsell-added-meta" class="upsell-modal__added-meta" style="display:none"></p>
              <p id="upsell-added-price" class="upsell-modal__added-price"></p>
            </div>
          </div>
          <div id="upsell-skeleton-section" class="upsell-section">
            <p class="upsell-section__heading">Har du alt du skal bruge?</p>
            <div class="upsell-skeleton-list">
              <div class="upsell-skeleton-item"><div class="upsell-skeleton__img-sq"></div><div class="upsell-skeleton__body"><div class="upsell-skeleton__line"></div><div class="upsell-skeleton__line upsell-skeleton__line--short"></div></div></div>
              <div class="upsell-skeleton-item"><div class="upsell-skeleton__img-sq"></div><div class="upsell-skeleton__body"><div class="upsell-skeleton__line"></div><div class="upsell-skeleton__line upsell-skeleton__line--short"></div></div></div>
            </div>
          </div>
          <div id="upsell-manual-section" class="upsell-section" style="display:none" aria-live="polite">
            <p class="upsell-section__heading">Har du alt du skal bruge?</p>
            <div class="upsell-list" id="upsell-manual-list"></div>
          </div>
          <div id="upsell-divider" class="upsell-divider" style="display:none"></div>
          <div id="upsell-related-section" class="upsell-section" style="display:none" aria-live="polite">
            <p class="upsell-section__heading">Andre kunder købte også</p>
            <div class="upsell-grid" id="upsell-related-grid"></div>
          </div>
        </div>
        <div class="upsell-modal__actions">
          <button class="upsell-modal__btn upsell-modal__btn--secondary" id="upsell-continue">Shop videre</button>
          <a class="upsell-modal__btn upsell-modal__btn--primary" href="/cart">
            Gå til kurv <span class="upsell-modal__cart-count" id="upsell-cart-count"></span>
          </a>
        </div>
      </div>
    `;
    document.body.appendChild(el);
    return el;
  }

  let overlay, lastFocusedElement;

  function init() {
    overlay = createModal();
    overlay.querySelector('.upsell-modal__close').addEventListener('click', closeModal);
    overlay.querySelector('#upsell-continue').addEventListener('click', closeModal);
    overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && overlay.style.display === 'flex') closeModal();
    });
  }

  let scrollPosition = 0;

  function openModal() {
    lastFocusedElement = document.activeElement;
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    overlay.style.display = 'flex';
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    setTimeout(() => overlay.querySelector('.upsell-modal__close').focus(), 50);
  }

  function closeModal() {
    overlay.style.display = 'none';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollPosition);
    if (lastFocusedElement) lastFocusedElement.focus();
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('da-DK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' kr.';
  }

  async function fetchCartCount() {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      const count = data.item_count || 0;

      const el = document.getElementById('upsell-cart-count');
      if (el) {
        el.textContent = count;
        el.setAttribute('aria-label', `${count} varer i kurv`);
      }

      const bubble = document.querySelector('.cart-link__bubble');
      const bubbleNum = document.querySelector('.cart-link__bubble-num');
      if (bubbleNum) bubbleNum.textContent = count;
      if (bubble) {
        if (count > 0) {
          bubble.classList.add('cart-link__bubble--visible');
        } else {
          bubble.classList.remove('cart-link__bubble--visible');
        }
      }
    } catch (_) {}
  }

  async function fetchManualProducts(tags) {
    const handles = tags.filter(t => t.startsWith('upsell_')).map(t => t.replace('upsell_', '').trim());
    if (handles.length === 0) return [];
    const results = await Promise.allSettled(
      handles.map(h => fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : Promise.reject()))
    );
    return results.filter(r => r.status === 'fulfilled').map(r => r.value);
  }

  async function fetchRelatedProducts(productId) {
    try {
      const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=6&intent=related`);
      const data = await res.json();
      return data.products || [];
    } catch (_) { return []; }
  }

  // ── Cart add — sender hele form data inkl. Infinite Options ──────────────────
  // valgtTil: navnet på det produkt tilbehøret blev valgt til (kun fra pop-up)
  async function addToCart(variantId, quantity, formData, valgtTil) {
    let body, contentType;

    if (formData) {
      // Brug hele form data så Infinite Options og andre apps' data kommer med
      formData.set('quantity', quantity);
      body = new URLSearchParams(formData).toString();
      contentType = 'application/x-www-form-urlencoded';
    } else {
      const data = { id: parseInt(variantId), quantity: parseInt(quantity) };
      if (valgtTil) {
        data.properties = { 'Valgt til': valgtTil };
      }
      body = JSON.stringify(data);
      contentType = 'application/json';
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': contentType },
      body: body
    });

    if (!res.ok) {
      const errData = await res.json().catch(() => ({}));
      const msg = errData.description || errData.message || 'Der opstod en fejl — prøv igen.';
      throw new Error(msg);
    }

    const item = await res.json();
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true, detail: { product: item } }));
    return item;
  }

  function buildActions(product, containerClass, valgtTil) {
    const variant = product.variants[0];
    const hasMultipleVariants = product.variants.length > 1;
    const isMetervare = product.type === 'Metervarer';
    const minQty = isMetervare ? 25 : 1;
    const wrap = document.createElement('div');
    wrap.className = containerClass;

    if (hasMultipleVariants) {
      wrap.innerHTML = `<a class="upsell-variant-btn" href="/products/${product.handle}" target="_self">Vælg variant →</a>`;
    } else {
      wrap.innerHTML = `
        <div class="upsell-qty" role="group" aria-label="Antal">
          <button class="upsell-qty__btn" data-action="minus" aria-label="Færre">−</button>
          <input class="upsell-qty__input" type="number" value="${minQty}" min="${minQty}" max="99999" aria-label="Antal">
          <button class="upsell-qty__btn" data-action="plus" aria-label="Flere">+</button>
        </div>
        <button class="upsell-add-btn" data-variant-id="${variant.id}" ${!variant.available ? 'disabled' : ''}>
          ${variant.available ? 'Læg i kurv' : 'Udsolgt'}
        </button>
      `;

      const input = wrap.querySelector('.upsell-qty__input');
      const addBtn = wrap.querySelector('.upsell-add-btn');
      input.addEventListener('focus', function () {
        setTimeout(function () { try { input.select(); } catch (e) {} }, 0);
      });      

      function resetAddBtn() {
        if (addBtn.classList.contains('is-added')) {
          addBtn.classList.remove('is-added');
          addBtn.textContent = 'Læg i kurv';
          addBtn.disabled = false;
        }
      }

      wrap.querySelector('[data-action="minus"]').addEventListener('click', () => {
        if (parseInt(input.value) > minQty) { input.value = parseInt(input.value) - 1; resetAddBtn(); }
      });
      wrap.querySelector('[data-action="plus"]').addEventListener('click', () => {
        input.value = parseInt(input.value) + 1; resetAddBtn();
      });
      input.addEventListener('input', resetAddBtn);
      input.addEventListener('blur', () => {
        const val = parseInt(input.value);
        if (isNaN(val) || val < minQty) input.value = minQty;
      });

      if (variant.available) {
        addBtn.addEventListener('click', async () => {
          const qty = parseInt(input.value) || minQty;
          addBtn.disabled = true;
          addBtn.textContent = '…';
          try {
            // Upsell produkter i popup bruger simpel JSON (ingen Infinite Options her)
            await addToCart(variant.id, qty, null, valgtTil);
            addBtn.textContent = '✓ Tilføjet';
            addBtn.classList.add('is-added');
            fetchCartCount();
          } catch (err) {
            addBtn.textContent = 'Prøv igen';
            addBtn.disabled = false;
            alert(err.message);
          }
        });
      }
    }
    return wrap;
  }

  function buildListCard(product, valgtTil) {
    const image = product.images[0];
    const variant = product.variants[0];
    const isMetervare = product.type === 'Metervarer';
    const card = document.createElement('div');
    card.className = 'upsell-list-card';
    card.innerHTML = `
      <img class="upsell-list-card__image" src="${image ? (image.src || image) : ''}" alt="${product.title}" loading="lazy" width="52" height="52">
      <div class="upsell-list-card__info">
        <a class="upsell-list-card__title" href="/products/${product.handle}" target="_self">${product.title}</a>
        <p class="upsell-list-card__price">${formatMoney(isMetervare ? variant.price * 100 : variant.price)}</p>
      </div>
    `;
    card.appendChild(buildActions(product, 'upsell-list-card__actions', valgtTil));
    return card;
  }

  function buildGridCard(product, valgtTil) {
    const image = product.images[0];
    const variant = product.variants[0];
    const isMetervare = product.type === 'Metervarer';
    const card = document.createElement('div');
    card.className = 'upsell-grid-card';
    card.innerHTML = `
      <img class="upsell-grid-card__image" src="${image ? (image.src || image) : ''}" alt="${product.title}" loading="lazy">
      <div class="upsell-grid-card__body">
        <a class="upsell-grid-card__title" href="/products/${product.handle}" target="_self">${product.title}</a>
        <p class="upsell-grid-card__price">${formatMoney(isMetervare ? variant.price * 100 : variant.price)}</p>
      </div>
    `;
    card.querySelector('.upsell-grid-card__body').appendChild(buildActions(product, 'upsell-grid-card__actions', valgtTil));
    return card;
  }

  async function showUpsellModal(item, quantity) {
    const productTitle = item.product_title || item.title || '';
    const isMetervare = item.product_type === 'Metervarer';
    const rawPrice = item.price || item.final_price || 0;
    const price = isMetervare ? rawPrice * 100 : rawPrice;
    const image = item.image || item.featured_image || '';
    const productId = item.product_id || item.id;

    document.getElementById('upsell-added-image').src = image || '';
    document.getElementById('upsell-added-image').alt = productTitle;
    document.getElementById('upsell-added-title').textContent = productTitle;
    document.getElementById('upsell-added-price').textContent = formatMoney(price);

    const metaEl = document.getElementById('upsell-added-meta');
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : null;
    const unit = isMetervare ? 'cm' : 'stk.';
    const metaParts = [variantTitle, quantity > 1 ? `${quantity} ${unit}` : null].filter(Boolean);
    if (metaParts.length > 0) {
      metaEl.textContent = metaParts.join(' · ');
      metaEl.style.display = '';
    } else {
      metaEl.textContent = '';
      metaEl.style.display = 'none';
    }

    document.getElementById('upsell-skeleton-section').style.display = '';
    document.getElementById('upsell-manual-section').style.display = 'none';
    document.getElementById('upsell-related-section').style.display = 'none';
    document.getElementById('upsell-divider').style.display = 'none';

    openModal();
    await fetchCartCount();

    let tags = [];
    try {
      const pRes = await fetch(`/products/${item.handle}.js`);
      const pData = await pRes.json();
      tags = pData.tags || [];
    } catch (_) {}

    const [manualProducts, relatedProducts] = await Promise.all([
      fetchManualProducts(tags),
      fetchRelatedProducts(productId)
    ]);

    document.getElementById('upsell-skeleton-section').style.display = 'none';

    const manualIds = new Set(manualProducts.map(p => p.id));
    const filteredRelated = relatedProducts.filter(p => !manualIds.has(p.id));

    if (manualProducts.length > 0) {
      const list = document.getElementById('upsell-manual-list');
      list.innerHTML = '';
      manualProducts.forEach(p => list.appendChild(buildListCard(p, productTitle)));
      document.getElementById('upsell-manual-section').style.display = '';
    }

    if (manualProducts.length > 0 && filteredRelated.length > 0) {
      document.getElementById('upsell-divider').style.display = '';
    }

    if (filteredRelated.length > 0) {
      const grid = document.getElementById('upsell-related-grid');
      grid.innerHTML = '';
      filteredRelated.slice(0, 6).forEach(p => grid.appendChild(buildGridCard(p, productTitle)));
      document.getElementById('upsell-related-section').style.display = '';
    }
  }

  // ── Intercept form submit — sender hele form data inkl. Infinite Options ─────
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form.matches('[data-type="add-to-cart-form"]')) return;

    e.preventDefault();

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    const qtyEl = document.querySelector('quantity-selector input[name="quantity"]')
      || document.querySelector('.metervare-qty__input');
    const quantity = qtyEl ? (parseInt(qtyEl.value) || 1) : 1;

    // Hent hele form data så Infinite Options og andre apps' data kommer med
    const formData = new FormData(form);

    try {
      const item = await addToCart(variantInput.value, quantity, formData);
      await showUpsellModal(item, quantity);
    } catch (err) {
      alert(err.message);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();